import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';

const SalaryForm = ({ 
  employees = [], 
  paymentMethods = [], 
  banks = [],
  mode = 'add' // 'add' or 'edit'
}) => {
  const { watch } = useFormContext();
  const selectedPaymentMethod = watch('payment_method_id');
  const selectedMethod = paymentMethods.find(pm => pm.id === Number.parseInt(selectedPaymentMethod, 10));

  const employeeOptions = employees.map(emp => ({
    value: emp.id,
    label: `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
  }));

  const paymentMethodOptions = paymentMethods.map(pm => ({
    value: pm.id,
    label: pm.name
  }));

  const bankOptions = banks.map(bank => ({
    value: bank.id,
    label: bank.name
  }));

  const currencyOptions = [
    { value: 'USD', label: 'USD' },
    { value: 'PKR', label: 'PKR' }
  ];

  return (
    <div className="space-y-4">
      <FormField
        name="employee_id"
        label="Employee"
        type="select"
        required={true}
        options={employeeOptions}
        validation={{ required: 'Employee is required' }}
        searchable={true}
        placeholder="Search employees..."
        data-testid="salary-form-field-employee"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="amount"
          label="Amount"
          type="number"
          step="0.01"
          required={true}
          validation={{ required: 'Amount is required' }}
          data-testid="salary-form-field-amount"
        />
        <FormField
          name="currency"
          label="Currency"
          type="select"
          required={true}
          options={currencyOptions}
          validation={{ required: 'Currency is required' }}
          data-testid="salary-form-field-currency"
        />
      </div>

      <FormField
        name="payment_method_id"
        label="Payment Method"
        type="select"
        required={true}
        options={paymentMethodOptions}
        validation={{ required: 'Payment method is required' }}
        data-testid="salary-form-field-payment-method"
      />

      {/* Conditional fields based on payment method */}
      {selectedMethod?.requires_bank_name && (
        <FormField
          name="bank_id"
          label="Bank"
          type="select"
          required={true}
          options={bankOptions}
          validation={{ required: 'Bank is required' }}
          data-testid="salary-form-field-bank"
        />
      )}

      {/* Each field follows its own flag: a title-only method (Cheque) still needs
          the Account Title input. */}
      {(selectedMethod?.requires_account_number || selectedMethod?.requires_account_title) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {selectedMethod.requires_account_number && (
            <FormField
              name="account_number"
              label="Account Number"
              required={true}
              validation={{ required: 'Account number is required' }}
              data-testid="salary-form-field-account-number"
            />
          )}
          {selectedMethod.requires_account_title && (
            <FormField
              name="account_title"
              label="Account Title"
              required={true}
              validation={{ required: 'Account title is required' }}
              data-testid="salary-form-field-account-title"
            />
          )}
        </div>
      )}

      <FormField
        name="effective_date"
        label="Effective Date"
        type="date"
        required={true}
        validation={{ required: 'Effective date is required' }}
        data-testid="salary-form-field-effective-date"
      />

      <FormField
        name="notes"
        label="Notes"
        type="textarea"
        placeholder="Optional notes about this salary record"
        data-testid="salary-form-field-notes"
      />
    </div>
  );
};

export default SalaryForm; 